import * as React from 'react';
import EditPartContainer, { EditPartContainerType } from '../EditPartContainer';
import EditPartLabelAndEditor from '../EditPartLabelAndEditor';
import EditExplanation from '../Editors/EditExplanation';
import { QuestionDownloadDto } from 'collaboration-service';

interface PrePostFixQuestionProps {
    epc: EditPartContainerType;
    registerClosed?: boolean;
}

const PrePostFixQuestion = (p: PrePostFixQuestionProps) => {
    const { epc, registerClosed } = p;
    return (
        <>
            <EditPartContainer icon="carousel" title="postfix Correct Explanation" {...epc} registerClosed={registerClosed}>
                <EditPartLabelAndEditor>
                    {[
                        { label: { icon: "tag", content: "explanation" }, editor: <EditExplanation<QuestionDownloadDto> getter={x => x.postfixCorrectExplanation!} /> },
                    ]}
                </EditPartLabelAndEditor>
            </EditPartContainer>
            <EditPartContainer icon="wiki" title="postfix Wrong Explanation" {...epc} registerClosed={registerClosed} >
                <EditPartLabelAndEditor>
                    {[
                        { label: { icon: "tag", content: "explanation" }, editor: <EditExplanation<QuestionDownloadDto> getter={x => x.postfixWrongExplanation!} /> },
                    ]}
                </EditPartLabelAndEditor>
            </EditPartContainer>
            <EditPartContainer icon="exclamation" title="prefix Explanation" {...epc} registerClosed={registerClosed} >
                <EditPartLabelAndEditor>
                    {[
                        { label: { icon: "tag", content: "explanation" }, editor: <EditExplanation<QuestionDownloadDto> getter={x => x.prefixExplanation!} /> },
                    ]}
                </EditPartLabelAndEditor>
            </EditPartContainer>
        </>
    );
}
export default PrePostFixQuestion;